/* eslint-disable @typescript-eslint/no-explicit-any */
import { useEffect, useRef, useState } from "react";

function useStateCallback(data: any) {
  const [state, setState] = useState(data);

  const cbQueueRef = useRef<((...args: any) => any)[]>([]);

  function setStateAndCallback(value: any, cb: (...args: any) => any) {
    const a = cbQueueRef.current;
    const t = [...a, cb];
    cbQueueRef.current = t;

    setState(value);
  }

  useEffect(() => {
    if (cbQueueRef.current.length > 0) {
      cbQueueRef.current.forEach((fn: (...args: any) => any) => {
        if (typeof fn === "function") {
          fn(state);
          cbQueueRef.current.shift();
        }
      });
    }
  }, [state]);

  return [state, setStateAndCallback];
}

export { useStateCallback };
